<template>
  <b-table responsive
           hover
           :items="livros"
           :fields="fields"
           :small="true"
           @row-clicked="onRowClick">
    <template slot="tipo_livro"
              slot-scope="data">
      {{ getLabelTipoLivro(data.item.tipo_livro) }}
    </template>
  </b-table>
</template>

<script>
  import { findTipoLivroByValue } from '@/common/registro'

  export default {
    name: 'ListagemLoteLivros',
    props: {
      livros: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        fields: [
          {
            key: 'num_livro',
            label: 'Livro',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'acervo',
            label: 'Acervo',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'tipo_livro',
            label: 'Tipo do registro',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'qtd_registros',
            label: 'Qtd registros',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'primeiro_termo',
            label: '1.º registro',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'ultimo_termo',
            label: 'Último registro',
            sortable: true,
            thClass: 'header-table'
          }
        ]
      }
    },

    methods: {
      getLabelTipoLivro (value) {
        return findTipoLivroByValue(value).text
      },
      onRowClick (livro) {
        this.$router.push({ name: 'lote_livro', params: { id: livro.livro_id } })
      }
    }
  }
</script>

<style lang="scss" scope>
  /deep/ table > tbody > tr {
    cursor: pointer;
  }
  .header-table {
    background-color: #01bfa5;
    font-size: 18px;
  }
</style>
